import { dictionary } from "../../languages";
import { stringInject } from "./utils";

const useTranslation = () => {
  return {
    t: (key: string, params?: string[]) =>
      (params && key && (dictionary as any)[key]
        ? stringInject((dictionary as any)[key], params)
        : (dictionary as any)[key]) || key,
  };
};

export default useTranslation;
